module.exports = __webpack_public_path__ + "img/Gabethegamer2011.60bde495.jpg";